import { Pipe, PipeTransform } from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';
import { ListInterface } from 'src/app/core/http/modal/workspace.interface';
/**
 * workspaceFilter
 */
@Pipe({
  name: 'workspaceFilter',
})
export class WorkspaceFilterPipe implements PipeTransform {
  constructor(private readonly us: UtilityService) {}
  /**
   *
   * @param values;
   * @param type;
   * string
   * @param args;
   * return array
   */
  transform(values: ListInterface[], filterType: number) {
    if (!values || values.length === 0) {
      return [];
    }

    if (filterType === 0) {
      let dW = null;
      if (this.us.getDefaultWorkspace()) {
        dW = this.us.getDefaultWorkspace();
      }
      return values.filter((obj: ListInterface) => {
        if (obj.workspaceHierarchy === dW) {
          obj['default'] = true;
        } else {
          obj['default'] = false;
        }
        return (
          obj.type.toUpperCase() === 'SELF' ||
          obj.status.toUpperCase() === 'APPROVED'
        );
      });
    } else if (filterType === 1) {
      return values.filter(
        (obj: ListInterface) =>
          obj.type.toUpperCase() === 'INITIATED' ||
          obj.status.toUpperCase() !== 'APPROVED'
      );
    } else {
      return values;
    }
  }
}
